export default __webpack_public_path__ + "static/media/main_intro_mobile.88c1d6e8.mp4";